import ValorisationStocksController from './valorisation.stocks.controller';
import Template from './valorisation.stocks.html';

export default {
	controller: ValorisationStocksController,
	template: Template
};
